import { createAction } from '@reduxjs/toolkit'

import type { Participant, ParticipantTag } from 'types/Participants'
import type { Project as ProjectType } from 'types/Project'
import { FetchParticipantNotesResponse } from 'types/ViewNotes'
import { FetchParticipantActivitiesResponse } from 'types/ViewActivities'

export const setLoading = createAction<boolean>('participantProfile/setLoading')

export const setParticipantTagsError = createAction<boolean>(
  'participantProfile/setParticipantTagsError',
)

export const setNotFound = createAction<boolean>(
  'participantProfile/setNotFound',
)

export const setParticipantSignupFormResponse = createAction(
  'participantProfile/setParticipantSignupFormResponse',
  function prepare(signupFormResponse: any) {
    return {
      payload: signupFormResponse.answers,
    }
  },
)

export const setParticipantSummary = createAction(
  'participantProfile/setParticipantSummary',
  function prepare(participant: Partial<Participant>) {
    return {
      payload: {
        participant,
      },
    }
  },
)

export const setParticipantNotes = createAction(
  'participantProfile/setParticipantNotes',
  function prepare(participantNotes: FetchParticipantNotesResponse) {
    return {
      payload: {
        participantNotes,
      },
    }
  },
)

export const setParticipantActivities = createAction(
  'participantProfile/setParticipantActivities',
  function prepare(participantActivities: FetchParticipantActivitiesResponse) {
    return {
      payload: {
        participantActivities,
      },
    }
  },
)

export const setParticipantTags = createAction(
  'participantProfile/setParticipantTags',
  function prepare(tags: ParticipantTag[]) {
    return {
      payload: {
        tags,
      },
    }
  },
)

export const setTags = createAction(
  'participantProfile/setTags',
  function prepare(tags: ParticipantTag[]) {
    return {
      payload: {
        tags,
      },
    }
  },
)

export const setProjects = createAction(
  'participantProfile/setProjects',
  (projects: ProjectType[]) => {
    return {
      payload: {
        projects,
      },
    }
  },
)

export const setActivitiesProjectId = createAction(
  'participantProfile/setActivitiesProjectId',
  (projectId: string) => {
    return {
      payload: {
        projectId,
      },
    }
  },
)

export const setNotesProjectId = createAction(
  'participantProfile/setNotesProjectId',
  (projectId: string) => {
    return {
      payload: {
        projectId,
      },
    }
  },
)

export const setNewNotesCount = createAction(
  'participantProfile/setNewNotesCount',
  (count: number) => {
    return {
      payload: count,
    }
  },
)

export const setSignupFormAnswers = createAction(
  'participantProfile/setSignupFormAnswers',
  function prepare(key, value) {
    return {
      payload: {
        key,
        value,
      },
    }
  },
)

export const setSignupFormQuestions = createAction(
  'participantProfile/setSignupFormQuestions',
  function prepare(questions) {
    return {
      payload: {
        questions,
      },
    }
  },
)

export const setSignupFormQuestionsLoading = createAction<boolean>(
  'participantProfile/setSignupFormQuestionsLoading',
)

export const setSignupFormErrors = createAction(
  'participantProfile/setSignupFormErrors',
  function prepare(value) {
    return {
      payload: {
        value,
      },
    }
  },
)
